/** Reports domain API — tipos puros del dominio. */

export type {
  BranchCashSessionReportRow,
  BranchSalesByProductRow,
  BranchSalesByProductResponse,
  PosExceptionSummary,
  ReportsOperacionKpiSources,
  ReportsOperacionSource,
  ReportsVentasProductScope,
  SalesByProductSortKey,
  SalesDailyRow,
} from './domain/reportsTypes';

export type {
  IntelligenceKpisPreset,
  IntelligenceKpisResponse,
  RentabilidadDailyRow,
  TurnoKpiHistoryRow,
} from './domain/reportsIntelligenceTypes';
export { INTELLIGENCE_SESSION_ERROR } from './domain/reportsIntelligenceTypes';

export type {
  PersonalBranchFacts,
  PersonalDashboardDTO,
  PersonalDashboardFacts,
  PersonalOperatorFacts,
  PersonalSignal,
  PersonalSignalSeverity,
  PersonalTeamMode,
} from './domain/reportsPersonalTypes';

export {
  emptyReportsQueryScope,
  reportsQueryScopeHasFilters,
  reportsQueryScopeToRpcParams,
  ventasProductScopeToQueryScope,
  type ReportsQueryScope,
  type ReportsQueryScopeRpcParams,
} from './domain/reportsQueryScope';

export { getBranchHealth, type BranchHealth, type BranchHealthStatus } from './domain/branchHealth';

export {
  buildPersonalDashboardDTO,
  countActivePersonalSignals,
  signalsForOperator,
} from './domain/evaluatePersonalDashboard';

export { PERSONAL_SIGNALS, evaluatePersonalSignals, flattenPersonalSignals } from './domain/personalSignalRegistry';

// ─── Purchases report (F3) ───────────────────────────────────────────────────
export type {
  PurchasesSummaryReport,
  PurchasesBySupplierRow,
  PurchasesByProductRow,
} from './domain/reportsPurchasesTypes';

export {
  aggregateOrderedVsReceived,
  orderedVsReceivedDiffs,
  weightedUnitCost,
} from './domain/orderedVsReceived';
export type { OrderedVsReceivedLine, OrderedVsReceivedRow } from './domain/orderedVsReceived';
export type { SupplierPerformanceRow } from './domain/reportsSupplierPerformanceTypes';
